import { SectionContainer } from "../components/SectionContainer";
import { GallerySection } from "../sections/GallerySection";

const Gallery = () => {
  return (
    <SectionContainer>
      <GallerySection />
    </SectionContainer>
  );
};

export default Gallery;
